import { Navigate } from '@sorare/routing';
import { FOOTBALL_ONBOARDING } from '@sorare/core/src/constants/__generated__/routes';

const OldOnboardingLayout = () => {
  /* IOS app is currently pointing to /football/play/pro/onboarding during onboarding flow */
  return <Navigate to={FOOTBALL_ONBOARDING} replace keepSearchParams />;
};
export default OldOnboardingLayout;
